/* LOGIN AUTH */
export const LOGIN = 'LOGIN';
export const GET_TOKEN = 'GET_TOKEN';
export const USER_SELECT = 'USER_SELECT';
export const USER_INSERT = 'USER_INSERT';
export const USER_CHECK_SESSION = 'USER_CHECK_SESSION';
export const USER_CHECK_LOGIN = 'USER_CHECK_LOGIN';


/* NOTICE */
export const NOTICE = 'NOTICE';
export const NOTICEDETAIL = 'NOTICEDETAIL';
export const NOTICEHIT = 'NOTICEHIT';
export const NOTICEURGENT = 'NOTICEURGENT';

/* BETA */
export const BETALIST = 'BETALIST';
export const BETADETAIL = 'BETADETAIL';
export const BETACATEGORY = 'BETACATEGORY';

/* COMMUNITY */
export const COMMUNITY_AUTHCODE = 'COMMUNITY_AUTHCODE';
export const REISSUE_ACCESS_TOKEN = 'REISSUE_ACCESS_TOKEN';
export const COMMUNITY_CATEGORY = 'COMMUNITYCATEGORY';
export const COMMUNITYLIST = 'COMMUNITYLIST';
export const COMMUNITYDETAIL = 'COMMUNITYDETAIL';
export const COMMUNITYINSERT = 'COMMUNITYINSERT';
export const COMMUNITYUPDATE = 'COMMUNITYUPDATE';
export const COMMUNITYDELETE = 'COMMUNITYDELETE';
export const COMMUNITYHIT = 'COMMUNITYHIT';
export const COMMUNITYFILEINSERT = 'COMMUNITYFILEINSERT';
export const COMMUNITYFILEDELETE = 'COMMUNITYFILEDELETE';
export const COMMUNITYFILEDOWNLOAD = 'COMMUNITYFILEDOWNLOAD';
export const COMMUNITY_COMMNET_LIST = 'COMMUNITY_COMMNET_LIST';
export const COMMUNITY_COMMNET_INSERT = 'COMMUNITY_COMMNET_INSERT';
export const COMMUNITY_COMMNET_UPDATE = 'COMMUNITY_COMMNET_UPDATE';
export const COMMUNITY_COMMNET_DELETE = 'COMMUNITY_COMMNET_DELETE';
export const COMMUNITY_FORM = 'COMMUNITY_FORM';
export const COMMUNITY_LIKE = 'COMMUNITY_LIKE';
export const COMMENT_POP = 'COMMENT_POP';
export const COMMENT_POP_UPDATE = 'COMMENT_POP_UPDATE';
export const COMMUNITY_EXCEL_DOWN = 'COMMUNITY_EXCEL_DOWN';

/* FAQ */
export const FAQLIST = 'FAQLIST';

/* POLICY */
export const POLICYLIST = 'POLICYLIST';
export const POLICYDETAIL = 'POLICYDETAIL';

/* PROFILES */
export const USERINFO_SELECT = 'USERINFO_SELECT';

/* OPINION */
export const OPINION_LIST = 'OPINION_LIST';
export const OPINION_DETAIL = 'OPINION_DETAIL';
export const OPINION_INSERT = 'OPINION_INSERT';
export const OPINION_UPDATE = 'OPINION_UPDATE';
export const OPINION_DELETE = 'OPINION_DELETE';
export const OPINION_CATEGORY = 'OPINION_CATEGORY';
export const OPINION_FILEDOWNLOAD = 'OPINION_FILEDOWNLOAD';
export const OPINION_FILEINSERT = 'OPINION_FILEINSERT';
export const OPINION_FILEDELETE = 'OPINION_FILEDELETE';